/**
 * Revert With Draft Undo Button Component
 *
 * Displays an undo button after a revert+draft operation.
 * Allows users to restore deleted messages and clear the draft.
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
type RevertWithDraftUndoButtonProps = {
  canUndo: boolean;
  undoInFlight: boolean;
  onUndo: () => void;
};
const RevertWithDraftUndoButton: React.FC<RevertWithDraftUndoButtonProps> = t0 => {
  const $ = _c(8);
  const {
    canUndo,
    undoInFlight,
    onUndo
  } = t0;
  if (!canUndo) {
    return null;
  }
  const t1 = `h-4 w-4 ${undoInFlight ? "animate-spin" : "group-hover:-rotate-45 transition-transform"}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" transform="scale(-1, 1) translate(-24, 0)" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <svg className={t1} fill="none" stroke="currentColor" viewBox="0 0 24 24">{t2}</svg>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = undoInFlight ? "Undoing Revert+Draft..." : "Undo Revert+Draft";
  let t5;
  if ($[3] !== onUndo || $[4] !== t3 || $[5] !== t4 || $[6] !== undoInFlight) {
    t5 = <div className="flex justify-center py-2"><button onClick={onUndo} disabled={undoInFlight} className="group flex items-center gap-2 rounded-lg border border-emerald-600/50 bg-emerald-600/10 px-4 py-2 text-sm font-medium text-emerald-300 shadow-md transition-all hover:bg-emerald-600/20 hover:border-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed" title="Undo the last revert+draft operation, restore deleted messages and clear draft">{t3}{t4}</button></div>;
    $[3] = onUndo;
    $[4] = t3;
    $[5] = t4;
    $[6] = undoInFlight;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default RevertWithDraftUndoButton;